import React, { Fragment } from 'react';
import { inject, observer } from 'mobx-react';

import FIELD_KEY_MAP from './field-key-map';

@inject('formStore')
@observer
class AgeInfo extends React.Component {
	render () {
		const { formStore, user } = this.props;
		const ageValid = formStore.validation[FIELD_KEY_MAP.dob];
		
		return (
			<Fragment>
				{(!ageValid && user.dob.length > 0) && ( 
					<div style={{textAlign:'center'}}>
						<div style={{color: "#ea0000"}}>You must be 13 years or older to sign up.</div>
					</div>
				)}
			</Fragment>
		)
	}
}

export default AgeInfo;
